@if (overlay().open()) {
  <div
    class="__overlay"
    [class.is-minimized]="overlay().minimized()"
    [class.is-maximized]="overlay().maximized()"
    [class.is-detached]="!overlay().docked()"
    [style.top.px]="dockedPosition()?.top"
    [style.left.px]="dockedPosition()?.left"
    [style.width.px]="dockedPosition()?.width"
    [style.height.px]="dockedPosition()?.height">

    <!-- Stays mounted across reloads and URL changes. Replacing the element would drop the embedded app's session storage. -->
    @if (sanitizedUrl()) {
      <iframe
        [src]="sanitizedUrl()"
        frameborder="0"
        allow="clipboard-read; clipboard-write">
      </iframe>
    }

    @if (loading()) {
      <div class="__message">
        <mat-icon class="__message_icon is-spinning" fontSet="material-icons-outlined">sync</mat-icon>
        <span>{{ loadingText() }}</span>
      </div>
    } @else if (!sanitizedUrl()) {
      <div class="__message">
        <mat-icon class="__message_icon" fontSet="material-icons-outlined">error_outline</mat-icon>
        <span>{{ emptyText() }}</span>
      </div>
    }

    <div class="__controls">
      <button
        mat-icon-button
        class="__controls_btn"
        (click)="overlay().minimize()"
        title="Minimize">
        <mat-icon fontSet="material-icons-outlined">minimize</mat-icon>
      </button>

      @if (overlay().maximized()) {
        <button
          mat-icon-button
          class="__controls_btn"
          (click)="overlay().unmaximize()"
          title="Exit fullscreen">
          <mat-icon fontSet="material-icons-outlined">close_fullscreen</mat-icon>
        </button>
      } @else {
        <button
          mat-icon-button
          class="__controls_btn"
          (click)="overlay().maximize()"
          title="Fullscreen">
          <mat-icon fontSet="material-icons-outlined">open_in_full</mat-icon>
        </button>
      }

      @if (url()) {
        <button
          mat-icon-button
          class="__controls_btn"
          [disabled]="loading()"
          (click)="reload.emit()"
          [title]="reloadTitle()">
          <mat-icon fontSet="material-icons-outlined">refresh</mat-icon>
        </button>
      }

      @if (showOpenInNewTab() && url()) {
        <button
          mat-icon-button
          class="__controls_btn"
          (click)="openInNewTab.emit()"
          [title]="newTabTitle()">
          <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
        </button>
      }

      <button
        mat-icon-button
        class="__controls_btn __controls_btn--close"
        (click)="closed.emit()"
        title="Close">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>
  </div>
}
